// leave empty value for compatibility's sake
export const APP_URL = ''; // Todo: use proxy
export const API_URL = `/api/v1`;
